
export const name = "documents-public-ui";
export const version = "dev";
